import React from 'react';
import PropTypes from 'prop-types';

import { openDecagonChat } from 'components/Decagon/Decagon.helpers';
import InfoBanner, { BANNER_VARIANTS } from 'components/InfoBanner/InfoBanner';
import { ICONS } from 'constants/icons';

import messages from './IntegratedPartnerBanner.messages';

import './IntegratedPartnerBanner.scss';

const IntegratedPartnerBanner = ({ integrationName }) => (
  <InfoBanner
    className="integrated-partner-banner"
    variant={BANNER_VARIANTS.GRAY}
    icon={ICONS.infoGreyLight}
    subtitle={messages.subtitle}
    subtitleValues={{ integrationName }}
    callToAction={messages.contactUs}
    onClick={openDecagonChat}
  />
);

IntegratedPartnerBanner.propTypes = {
  integrationName: PropTypes.string.isRequired,
};

export default IntegratedPartnerBanner;
